import React, { useEffect, useState } from 'react'
import { useConfigState } from '@sentecacommerce-theme/lib'
import Head from 'next/head'

export const ThirdPartyScripts = () => {
  const config = useConfigState()

  const [page, setPage] = useState({ location: '', path: '', title: '' })

  useEffect(() => {
    setPage({
      location: window.location.href,
      path: window.location.pathname,
      title: window.document.title,
    })
  }, [])

  return (
    <>
      <Head>
        <script
          dangerouslySetInnerHTML={{
            __html: `
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${config.analytics.googleTagManager}');`,
          }}
        />

        <script
          async
          src={`https://www.googletagmanager.com/gtag/js?id=${config.analytics.googleAnalytics}`}
        ></script>
        <script
          dangerouslySetInnerHTML={{
            __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());

            gtag('config', '${config.analytics.googleAnalytics}');`,
          }}
        />

        <script
          async
          src={`https://www.googletagmanager.com/gtag/js?id=${config.analytics.googleAds}`}
        ></script>
        <script
          dangerouslySetInnerHTML={{
            __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}

            gtag('js', new Date());
            gtag('config', '${config.analytics.googleAds}');`,
          }}
        />
        <script
          dangerouslySetInnerHTML={{
            __html: `
          gtag("event", "page_view", {
            page_location: "${page.location}",
            page_path: "${page.path}",
            page_title: "${page.title}"
          });`,
          }}
        />

        <script
          dangerouslySetInnerHTML={{
            __html: `
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');

            fbq('init', '${config.analytics.facebookPixel}');
            fbq('track', 'PageView');
      `,
          }}
        />
      </Head>

      <noscript>
        <iframe
          title="googleTagManager"
          src={`https://www.googletagmanager.com/ns.html?id=${config.analytics.googleTagManager}`}
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
        ></iframe>
      </noscript>

      <noscript>
        <img
          height="1"
          width="1"
          style={{ display: 'none' }}
          src={`https://www.facebook.com/tr?id=${config.analytics.facebookPixel}&ev=PageView&noscript=1`}
          alt="Hippoland"
        />
      </noscript>
    </>
  )
}
